module.exports = __webpack_public_path__ + "img/clock.59489b86.svg";